import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { useStaffLogout } from "./useStaffLogout";
import { useStaffAuthContext } from "./useStaffAuthContext";
import logo from "../../images/amax-center-circle-logo.png";
import staffIcon from "../../images/staff-icon.svg";
import athlete from "../../images/athlete-white-icon.svg";
import library from "../../images/library-white-icon.svg";
import speed from "../../images/speed-white-icon.svg";
import strength from "../../images/strength-white-icon.svg";
import messages from "../../images/messages-white-icon.svg";
import runrocket from "../../images/runrocket-white-icon.svg";
import logoutIcon from "../../images/logout-white-icon.svg";
import hamburger from "../../images/hamburgerWhite.svg";

export const StaffSideMenu = () => {
  const { staff } = useStaffAuthContext();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [toggleStaffMenu, setToggleStaffMenu] = useState(false);
  const [toggleAthleteMenu, setToggleAthleteMenu] = useState(false);
  const [toggleCoachMenu, setToggleCoachMenu] = useState(false);

  const [toggleExerciseLibraryMenu, setToggleExerciseLibraryMenu] =
    useState(false);
  const [toggleTemplateSpeedMenu, setToggleTemplateSpeedMenu] = useState(false);
  const [toggleTemplateStrengthMenu, setToggleTemplateStrengthMenu] =
    useState(false);

  const [toggleWarmupRoutineMenu, setToggleWarmupRoutineMenu] = useState(false);
  const [toggleStaticSpeedWorkoutMenu, setToggleStaticSpeedWorkoutMenu] =
    useState(false);
  const [toggleStaticStrengthWorkoutMenu, setToggleStaticStrengthWorkoutMenu] =
    useState(false);
  const [toggleMessageMenu, setToggleMessageMenu] = useState(false);
  const [toggleRunrocketMenu, setToggleRunrocketMenu] = useState(false);
  const [toggleLoadvelocityMenu, setToggleLoadvelocityMenu] = useState(false);

  const { logout } = useStaffLogout();
  const location = useLocation(); // To track the current location

  const [openMenu, setOpenMenu] = useState(null);
  const handleDropdown = (menu) => {
  setOpenMenu((prev) => (prev === menu ? null : menu));
};

  const handleLogoutClick = () => {
    logout();
  };

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const staffDropdownClick = () => setToggleStaffMenu(!toggleStaffMenu);
  const athleteDropdownClick = () => setToggleAthleteMenu(!toggleAthleteMenu);
  const coachDropdownClick = () => setToggleCoachMenu(!toggleCoachMenu);

  const exerciseLibraryDropdownClick = () =>
    setToggleExerciseLibraryMenu(!toggleExerciseLibraryMenu);
  const templateSpeedDropdownClick = () =>
    setToggleTemplateSpeedMenu(!toggleTemplateSpeedMenu);
  const templateStrengthDropdownClick = () =>
    setToggleTemplateStrengthMenu(!toggleTemplateStrengthMenu);

  const warmupRoutineDropdownClick = () =>
    setToggleWarmupRoutineMenu(!toggleWarmupRoutineMenu);
  const staticSpeedWorkoutDropdownClick = () =>
    setToggleStaticSpeedWorkoutMenu(!toggleStaticSpeedWorkoutMenu);
  const staticStrengthWorkoutDropdownClick = () =>
    setToggleStaticStrengthWorkoutMenu(!toggleStaticStrengthWorkoutMenu);
  const messageDropdownClick = () => setToggleMessageMenu(!toggleMessageMenu);
  const runrocketDropdownClick = () =>
    setToggleRunrocketMenu(!toggleRunrocketMenu);
  const loadvelocityDropdownClick = () =>
    setToggleLoadvelocityMenu(!toggleLoadvelocityMenu);

  // Function to add active class based on the current path
  const isActivePathImgWrapper = (path) =>
    location.pathname === path ? "bg-white" : "group-hover:bg-white";

  const isActivePathImg = (path) =>
    location.pathname === path ? "invert" : "group-hover:invert";

  return (
    <>
      {/* Toggle Button for Mobile */}
      <button
        onClick={toggleMenu}
        className={`md:hidden fixed top-4 left-6 bg-dark size-8 rounded-sm flex justify-center items-center z-20 ${
          isMenuOpen ? "hidden" : "block"
        }`}
      >
        <img src={hamburger} alt="hamburger" className="w-6 h-6" />
      </button>

      {/* Sidebar */}
      <div
        className={`bg-dark text-white flex-none w-44 md:w-24 transition-transform transform pt-16 pb-5 md:py-4 ${
          isMenuOpen ? "translate-x-0" : "-translate-x-44"
        } md:translate-x-0 md:relative h-full fixed z-10 md:flex-none`}
        // className={`bg-blue-600 text-white w-64 transition-transform transform ${
        //   isMenuOpen ? "translate-x-0" : "-translate-x-64"
        // } md:translate-x-0 md:static fixed z-10 h-full max-h-screen overflow-y-auto`}
      >
        {/* Close Button for Mobile */}
        <button
          onClick={toggleMenu}
          className="absolute top-4 left-8 md:hidden bg-white size-8 rounded-sm flex justify-center items-center text-black text-xl"
        >
          ✕
        </button>
        {/* logo */}
        <div>
          {/* <Link to="/administrator/dashboard">AMAX Admins</Link> */}
          <Link
            to="/administrator/dashboard"
            className="block w-[68px] mx-auto"
          >
            <img src={logo} alt="logo" className="w-full h-full" />
          </Link>
        </div>
        {/* links */}

        <ul className="space-y-5 md:space-y-6 mt-8 px-3">
          {/* Increased space between items */}
          {/* ✅ Staff menu only for master_admin */}
          {staff?.role === "master_admin" && (
            <li className="relative">
              <Link
                to="/administrator/staff/manage"
                className={`relative group w-full transition duration-200 font-apercu font-normal text-center text-xs leading-3 flex flex-col justify-center items-center gap-1 md:gap-2`}
                // className={`relative group w-full transition duration-200 ${isActivePath("/administrator/staff/manage")} font-apercu font-normal text-center text-xs leading-3 flex flex-col justify-center items-center gap-3`}
              >
                <div
                  className={`size-9 rounded-full flex justify-center items-center ${isActivePathImgWrapper("/administrator/staff/manage")}`}
                >
                  <img
                    src={staffIcon}
                    alt="icon"
                    className={`size-6 ${isActivePathImg("/administrator/staff/manage")}`}
                  />
                </div>
                Staff
              </Link>
            </li>
          )}
          <li className="relative">
            <Link
              to="/administrator/athlete/manage"
              className={`relative group w-full transition duration-200 font-apercu font-normal text-center text-xs leading-3 flex flex-col justify-center items-center gap-1 md:gap-2`}
            >
              <div
                className={`size-9 rounded-full flex justify-center items-center ${isActivePathImgWrapper("/administrator/athlete/manage")}`}
              >
                <img
                  src={athlete}
                  alt="icon"
                  className={`size-6 ${isActivePathImg("/administrator/athlete/manage")}`}
                />
              </div>
              Athletes
            </Link>
          </li>
          {/* <li className="border-b border-white"> 
            <button
              onClick={coachDropdownClick}
              className="w-full text-left px-6 py-4 hover:bg-blue-700 transition duration-200" 
            >
              Coaches
            </button>
            {toggleCoachMenu && (
              <ul className="pl-8 space-y-3">
                <li>
                  <Link
                    to="/administrator/coach/manage"
                    className={`w-full text-left px-6 py-2 ${isActivePath('/administrator/coach/manage')} hover:bg-blue-500 transition duration-200`}
                  >
                    View Coaches
                  </Link>
                </li>
                <br/>
              </ul>
            )}
          </li> */}
          <li className="relative">
            <Link
              to="/administrator/exercise-library/manage"
              className={`relative group w-full transition duration-200 font-apercu font-normal text-center text-xs leading-3 flex flex-col justify-center items-center gap-1 md:gap-2`}
            >
              <div
                className={`size-9 rounded-full flex justify-center items-center ${isActivePathImgWrapper("/administrator/exercise-library/manage")}`}
              >
                <img
                  src={library}
                  alt="icon"
                  className={`size-6 ${isActivePathImg("/administrator/exercise-library/manage")}`}
                />
              </div>
              {/* Exercise Library */}
              Library
            </Link>
          </li>
          <li className="relative">
            {" "}
            {/* Added divider */}
            <button
              onClick={() => handleDropdown("speed")}
              className="relative group w-full transition duration-200 font-apercu font-normal text-center text-xs leading-3 flex flex-col justify-center items-center gap-1 md:gap-2"
            >
              <div
                className={`size-9 rounded-full flex justify-center items-center ${toggleTemplateSpeedMenu && "bg-white"} group-hover:bg-white`}
              >
                <img
                  src={speed}
                  alt="icon"
                  className={`size-6 group-hover:invert ${toggleTemplateSpeedMenu && "invert"}`}
                />
              </div>
              Speed
            </button>
             {openMenu === "speed" && (
              <div className="relative max-md:mt-3 md:absolute md:-top-3 md:left-full md:pl-3 bg-dark md:rounded-tr-lg md:rounded-br-lg">
                <ul className="space-y-2.5 md:w-32 py-2.5 w-full text-center max-md:bg-black/50 max-md:px-2 max-md:rounded-lg">
                  {" "}
                  {/* Adjusted space */}
                  <li>
                    <Link
                      to="/administrator/template-speed/warmup-routine/manage"
                      className={`transition duration-200 font-apercu font-normal text-center text-xs leading-3 md:pr-3 hover:underline`}
                      // className={`w-full text-left px-6 py-2 ${isActivePath("/administrator/template-speed/warmup-routine/manage")} hover:bg-blue-500 transition duration-200`}
                    >
                      Warmup Programs
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/administrator/template-speed/training-focus/manage"
                      className={`transition duration-200 font-apercu font-normal text-center text-xs leading-3 md:pr-3 hover:underline`}
                      // className={`w-full text-left px-6 py-2 ${isActivePath("/administrator/template-speed/training-focus/manage")} hover:bg-blue-500 transition duration-200`}
                    >
                      Training Workouts
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/administrator/template-speed/training-template/manage"
                      className={`transition duration-200 font-apercu font-normal text-center text-xs leading-3 md:pr-3 hover:underline`}
                      // className={`w-full text-left px-6 py-2 ${isActivePath("/administrator/template-speed/training-template/manage")} hover:bg-blue-500 transition duration-200`}
                    >
                      Training Programs
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/administrator/template-speed/products/manage"
                      className={`transition duration-200 font-apercu font-normal text-center text-xs leading-3 md:pr-3 hover:underline`}
                      // className={`w-full text-left px-6 py-2 ${isActivePath("/administrator/template-speed/products/manage")} hover:bg-blue-500 transition duration-200`}
                    >
                      Products
                    </Link>
                  </li>
                </ul>
                <TopShape />
                <BottomShape />
              </div>
            )}
          </li>
          <li className="relative">
            {" "}
            {/* Added divider */}
            <button
              onClick={() => handleDropdown("strength")}
              className="relative group w-full transition duration-200 font-apercu font-normal text-center text-xs leading-3 flex flex-col justify-center items-center gap-1 md:gap-2"
            >
              <div
                className={`size-9 rounded-full flex justify-center items-center ${toggleTemplateStrengthMenu && "bg-white"} group-hover:bg-white`}
              >
                <img
                  src={strength}
                  alt="icon"
                  className={`size-6 group-hover:invert ${toggleTemplateStrengthMenu && "invert"}`}
                />
              </div>
              Strength
            </button>
            {openMenu === "strength" && (
              <div className="relative max-md:mt-3 md:absolute md:-top-3 md:left-full md:pl-3 bg-dark md:rounded-tr-lg md:rounded-br-lg">
                <ul className="space-y-2.5 md:w-32 py-2.5 w-full text-center max-md:bg-black/50 max-md:px-2 max-md:rounded-lg">
                  {" "}
                  {/* Adjusted space */}
                  <li>
                    <Link
                      to="/administrator/template-strength/training-focus/manage"
                      className={`transition duration-200 font-apercu font-normal text-center text-xs leading-3 md:pr-3 hover:underline`}
                      // className={`${isActivePath("/administrator/template-strength/training-focus/manage")} transition duration-200`}
                    >
                      Training Workouts
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/administrator/template-strength/products/manage"
                      className={`transition duration-200 font-apercu font-normal text-center text-xs leading-3 md:pr-3 hover:underline`}
                      // className={`${isActivePath("/administrator/template-strength/products/manage")} transition duration-200`}
                    >
                      Products
                    </Link>
                  </li>
                </ul>
                <TopShape />
                <BottomShape />
              </div>
            )}
          </li>
          {/*   <li className="border-b border-white"> 
            <button
              onClick={warmupRoutineDropdownClick}
              className="w-full text-left px-6 py-4 hover:bg-blue-700 transition duration-200" 
            >
              Warmup Routine Library (OLD)
            </button>
            {toggleWarmupRoutineMenu && (
              <ul className="pl-8 space-y-3"> 
             
                <li>
                  <Link
                    to="/administrator/warmup-routine/manage-phase"
                    className={`w-full text-left px-6 py-2 ${isActivePath('/administrator/warmup-routine/manage-phase')} hover:bg-blue-500 transition duration-200`}
                  >
                    Manage Phases & Ex
                  </Link>
                </li>
                
                <li>
                  <Link
                    to="/administrator/warmup-routine/static/manage"
                    className={`w-full text-left px-6 py-2 ${isActivePath('/administrator/warmup-routine/static/manage')} hover:bg-blue-500 transition duration-200`}
                  >
                  Manage Static Templates              
                  </Link>
                </li>

                <br/>
              </ul>
            )}
          </li> */}
          {/* <li className="border-b border-white"> 
            <button
              onClick={staticSpeedWorkoutDropdownClick}
              className="w-full text-left px-6 py-4 hover:bg-blue-700 transition duration-200" 
            >
             Static Speed Workout (OLD)
            </button>
            {toggleStaticSpeedWorkoutMenu && (
              <ul className="pl-8 space-y-3"> 
              
                <li>
                  <Link
                    to="/administrator/static-speed-workout/manage-template"
                    className={`w-full text-left px-6 py-2 ${isActivePath('/administrator/static-speed-workout/manage-template')} hover:bg-blue-500 transition duration-200`}
                  >
                    Manage Static Templates
                  </Link>
                </li>

                <br/>
              </ul>
            )}
          </li> */}
          {/* <li className="border-b border-white"> 
            <button
              onClick={staticStrengthWorkoutDropdownClick}
              className="w-full text-left px-6 py-4 hover:bg-blue-700 transition duration-200" 
            >
             Static Strength Workout (OLD)
            </button>
            {toggleStaticStrengthWorkoutMenu && (
              <ul className="pl-8 space-y-3"> 
              
                <li>
                  <Link
                    to="/administrator/static-strength-workout/manage-exercise"
                    className={`w-full text-left px-6 py-2 ${isActivePath('/administrator/static-strength-workout/manage-exercise')} hover:bg-blue-500 transition duration-200`}
                  >
                    Manage Exercise Library
                  </Link>
                </li>

                <li>
                  <Link
                    to="/administrator/static-strength-workout/manage-template"
                    className={`w-full text-left px-6 py-2 ${isActivePath('/administrator/static-strength-workout/manage-template')} hover:bg-blue-500 transition duration-200`}
                  >
                    Manage Static Templates
                  </Link>
                </li>

                <br/>
              </ul>
            )}
          </li> */}
          <li className="relative">
            <Link
              to="/administrator/message/manage-athlete-message"
              className={`group w-full transition duration-200 font-apercu font-normal text-center text-xs leading-3 flex flex-col justify-center items-center gap-3`}
            >
              <div
                className={`size-9 rounded-full flex justify-center items-center ${isActivePathImgWrapper("/administrator/message/manage-athlete-message")}`}
              >
                <img
                  src={messages}
                  alt="icon"
                  className={`size-6 ${isActivePathImg("/administrator/message/manage-athlete-message")}`}
                />
              </div>
              Messages
            </Link>
          </li>
          <li className="relative">
            {" "}
            {/* Added divider */}
            <button
               onClick={() => handleDropdown("runrocket")}
              className="relative group w-full transition duration-200 font-apercu font-normal text-center text-xs leading-3 flex flex-col justify-center items-center gap-1 md:gap-2"
            >
              <div
                className={`size-9 rounded-full flex justify-center items-center ${toggleRunrocketMenu && "bg-white"} group-hover:bg-white`}
              >
                <img
                  src={runrocket}
                  alt="icon"
                  className={`size-6 group-hover:invert ${toggleRunrocketMenu && "invert"}`}
                />
              </div>
              AST Speed Profile™
            </button>
            {openMenu === "runrocket" && (
              <div className="relative max-md:mt-3 md:absolute md:-top-3 md:left-full md:pl-3 md:bg-dark md:rounded-tr-lg md:rounded-br-lg">
                <ul className="space-y-2.5 md:w-32 py-2.5 w-full text-center max-md:bg-black/50 max-md:px-2 max-md:rounded-lg">
                  {" "}
                  {/* Adjusted space */}
                  <li>
                    <Link
                      to="/administrator/runrocket/templates/manage" 
                      className={`transition duration-200 font-apercu font-normal text-center text-xs leading-3 md:pr-3 hover:underline`}
                      // className={`w-full text-left px-6 py-2 ${isActivePathImgWrapper("/administrator/runrocket/templates/manage")} hover:bg-blue-500 transition duration-200`}
                    >
                      Manage Templates
                    </Link>
                  </li>
                </ul>
                <TopShape />
                <BottomShape />
              </div>
            )}
          </li>
          {/* <li className="border-b border-white"> 
            <button
              onClick={loadvelocityDropdownClick}
              className="w-full text-left px-6 py-4 hover:bg-blue-700 transition duration-200" 
            >
              Loadvelocity
            </button>
            {toggleLoadvelocityMenu && (
              <ul className="pl-8 space-y-3">
                <li>
                  <Link
                    to="/administrator/loadvelocity/templates/manage"
                    className={`w-full text-left px-6 py-2 ${isActivePath('/administrator/loadvelocity/templates/manage')} hover:bg-blue-500 transition duration-200`}
                  >
                    Manage Templates
                  </Link>
                </li>
                <br/>
              </ul>
            )}
          </li> */}
          <li className="relative">
            <button
              onClick={handleLogoutClick}
              className="relative group w-full transition duration-200 font-apercu font-normal text-center text-xs leading-3 flex flex-col justify-center items-center gap-1 md:gap-2"
            >
              <img src={logoutIcon} alt="icon" className="size-6" />
              Logout
            </button>
          </li>
        </ul>
      </div>
    </>
  );
};

const TopShape = () => {
  return (
    <>
      {/* top shape */}
      <div className="md:absolute md:-top-[11px] md:left-[11px] md:size-3 max-md:hidden">
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 12V0C2.4 8 9 11.3333 12 12H0Z" fill="#161616" />
        </svg>
      </div>
    </>
  );
};

const BottomShape = () => {
  return (
    <>
      {/* bottom shape */}
      <div className="md:absolute md:-bottom-[11px] md:left-[11px] md:size-3 rotate-90 max-md:hidden">
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 12V0C2.4 8 9 11.3333 12 12H0Z" fill="#161616" />
        </svg>
      </div>
    </>
  );
};
